import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient, ApiResponseError } from "~/utils";

import { ApisMembersInsightPostCommentsInsightPostWithCommentsShowResponseType } from "~/domains";

type ParamsType = {
  insightPostCommentId: string;
};

const request = async ({
  insightPostCommentId,
}: ParamsType): Promise<ApisMembersInsightPostCommentsInsightPostWithCommentsShowResponseType> => {
  const response =
    await new ApiClient().get<ApisMembersInsightPostCommentsInsightPostWithCommentsShowResponseType>(
      `/api/members/insight_post_comments/${insightPostCommentId}/insight_post_with_comments`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  insightPostCommentId: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersInsightPostCommentsInsightPostWithCommentsShow = ({
  insightPostCommentId,
  config = {},
}: PropsType): UseQueryResult<ApisMembersInsightPostCommentsInsightPostWithCommentsShowResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [
      "ApisMembersInsightPostCommentsInsightPostWithCommentsShow",
      insightPostCommentId,
    ],
    queryFn: () => request({ insightPostCommentId }),
    useErrorBoundary: (error) => {
      return error instanceof ApiResponseError && error.status >= 500;
    },
  });
};
